import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "extraJSONData", "screen", "subscreen", "TrackedComponent", "trackableKey", "tracked", "immediate"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import { ScreenTrackingContextConsumer } from 'automation-ui-usage-tracking/ScreenTrackingContext';
import { SubscreenTrackingContextConsumer } from 'automation-ui-usage-tracking/SubscreenTrackingContext';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TRACKED = ['onClick'];
class TrackableGeneric extends Component {
  handleTrackableMount(extraJSONData, immediate) {
    const {
      usageTracker,
      immediateUsageTracker
    } = this.context;
    const {
      tracked,
      trackableKey
    } = this.props;
    const tracker = immediate ? immediateUsageTracker : usageTracker;
    this.tracked = tracked.filter(handlerName => typeof this.props[handlerName] === 'function').reduce((handled, handlerName) => {
      handled[handlerName] = (...args) => {
        trackEvent(tracker, trackableKey, extraJSONData);
        this.props[handlerName](...args);
      };
      return handled;
    }, {});
  }
  render() {
    const _this$props = this.props,
      {
        children,
        extraJSONData,
        screen,
        subscreen,
        TrackedComponent
        // eslint-disable-line @typescript-eslint/no-unused-vars
        ,

        // eslint-disable-line @typescript-eslint/no-unused-vars
        immediate
      } = _this$props,
      origProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const screenTrackingData = {};
    if (screen) {
      screenTrackingData.screen = screen;
    }
    if (subscreen) {
      screenTrackingData.subscreen = subscreen;
    }
    this.handleTrackableMount(Object.assign({}, extraJSONData, screenTrackingData), immediate);
    const propsWithTrackedEvents = Object.assign({}, origProps, this.tracked);
    return /*#__PURE__*/_jsx(TrackedComponent, Object.assign({}, propsWithTrackedEvents, {
      children: children
    }));
  }
}

// TODO: JM: abstract this
TrackableGeneric.contextType = UsageTrackerContext;
TrackableGeneric.propTypes = {
  children: PropTypes.any,
  extraJSONData: PropTypes.object,
  immediate: PropTypes.bool,
  screen: PropTypes.string,
  subscreen: PropTypes.string,
  trackableKey: PropTypes.oneOf(Object.keys(Trackables)).isRequired,
  tracked: PropTypes.arrayOf(PropTypes.string),
  TrackedComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};
TrackableGeneric.defaultProps = {
  extraJSONData: {},
  tracked: DEFAULT_TRACKED,
  immediate: false
};
const TrackableGenericWithContext = props => /*#__PURE__*/_jsx(ScreenTrackingContextConsumer, {
  children: screen => /*#__PURE__*/_jsx(SubscreenTrackingContextConsumer, {
    children: subscreen => {
      return /*#__PURE__*/_jsx(TrackableGeneric, Object.assign({
        screen: screen,
        subscreen: subscreen
      }, props));
    }
  })
});
export default TrackableGenericWithContext;